import { CheckRecord } from '@q6cyber/proto2es/generated/reporting';

import { FormControl, FormGroup } from '@angular/forms';

import { RouterOutput } from '../../../utils';
import { CorruptedData } from './generic-data.interface';

/**
 * A single row in the check-records results list.
 *
 * Mirrors an edge returned by `checkRecord.list`, but with the raw `node`
 * replaced by a parsed `CheckRecord` proto (or `null` when the payload could
 * not be validated) plus the shared corrupted-data markers.
 */
export interface CheckRecordListResponse
  extends
    Omit<RouterOutput['checkRecord']['list']['edges'][0], 'node'>,
    CorruptedData {
  node: CheckRecord | null;
}

export type CheckRecordTotalRelation = 'approximate' | 'exact';

export interface CheckRecordCountMetadata {
  totalRelation: CheckRecordTotalRelation;
}

export const checkRecordFiltersForm = () =>
  new FormGroup({
    startDate: new FormControl<string>(''),
    endDate: new FormControl<string>(''),
    query: new FormControl<string>(''),
  });

export type CheckRecordFilterOptions = ReturnType<
  ReturnType<typeof checkRecordFiltersForm>['getRawValue']
>;
